export const acomQnATexts = {
  title: {
    default: 'vem tirar sua dúvida :)',
    customerQuestions: 'suas perguntas :)',
    noQuestions: 'Faça a primeira :)',
  },
  statusTermFound: (number = 0) => {
    const plural = isPlural(number);
    return number ? `oooba, ${number} resultado${plural} encontrado${plural} :)` : '';
  },
  termNotFound: {
    title: 'poxa, nenhum resultado encontrado',
    subtitle: 'O que você pode fazer?',
    suggestions: {
      hintOne: 'Ver se o termo digitado tá certinho e tentar pesquisar de novo ou',
      hintTwo: 'Fazer uma pergunta pra gente ;)',
    },
  },
};

export const subaQnATexts = {
  title: {
    default: 'Vem tirar sua dúvida, Sublover \\o/',
    customerQuestions: 'Suas perguntas \\o/',
    noQuestions: 'Faça a primeira \\o/',
  },
  statusTermFound: (number = 0) => {
    const plural = isPlural(number);
    return number ? `O Sub encontrou ${number} resultado${plural} \o/` : '';
  },
  termNotFound: {
    title: 'Poxa, nenhum resultado encontrado',
    subtitle: 'O que você pode fazer?',
    suggestions: {
      hintOne: 'Ver se o termo digitado tá correto e tentar pesquisar de novo ou',
      hintTwo: 'Fazer uma pergunta pro Sub \\o/',
    },
  },
};

export const shopQnATexts = {
  title: {
    default: 'Tire suas dúvidas',
    customerQuestions: 'Suas perguntas',
    noQuestions: 'Faça a primeira pergunta.',
  },
  statusTermFound: (number = 0) => {
    const plural = isPlural(number);
    return number ? `${number} resultado${plural} encontrado${plural}  ` : '';
  },
  termNotFound: {
    title: 'Nenhum resultado encontrado',
    subtitle: 'O que você pode fazer?',
    suggestions: {
      hintOne: 'Ver se o termo digitado tá correto e tentar pesquisar de novo ou',
      hintTwo: 'Fazer uma pergunta pra gente.',
    },
  },
};

const isPlural = (number = 0) => (number > 1 ? 's' : '');
